import React from 'react';
import Backend from '../../../Layouts/Backend';
import {
  Form,
  FormFeedback,
  FormGroup,
  Label,
  Input as ReactstrapInput,
} from 'reactstrap';
import { Alert, Button, Input } from '../../../UI/Common';
import { useFormik } from 'formik';
import { CustomRadioBtn } from '../../../UI/CustomForm';
import { useTranslation } from 'react-i18next';
import { validationSchema } from './validation';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Loading from '../../../Helpers/Loading';

const _period = [
  { value: '0', label: 'Day' },
  { value: '1', label: 'Week' },
  { value: '2', label: 'Month' },
];
const ModifyEmailSchedulePage = ({ form, onSubmit, ...props }) => {
  const { t, i18n } = useTranslation('app');
  let timeFormat = 'HH:mm';
  if (i18n.language === 'en_US') {
    timeFormat = 'h:mm aa';
  }
  const {
    handleChange,
    setFieldValue,
    values,
    errors,
    touched,
    handleSubmit,
    ...formik
  } = useFormik({
    initialValues: form,
    validationSchema,
    onSubmit: () => onSubmit(values),
  });
  React.useEffect(() => {
    formik.setValues(form);
  }, [form]);
  function renderText(frequencyType) {
    if (frequencyType === '1') {
      return 'week';
    } else return 'month';
  }
  return (
    <Backend>
      <div className="content-inner">
        <Form className="w-50">
          <div className="d-flex align-items-end">
            <Input
              required
              label="Unlock Code"
              containerStyle={{ flex: 1, marginRight: 15 }}
              onChange={handleChange('code')}
              value={values.code}
              invalid={errors.code && touched.code}
              error={errors.code}
              readOnly={props.isActive}
            />
            <Button
              classes="mb-15"
              onClick={() => props.onUnlock(values.code)}
              disabled={props.isActive || !values.code}
            >
              {t('Unlock')}
            </Button>
          </div>
          {props.isActive ? (
            props.wait4GetSchedule ? (
              <Loading />
            ) : (
              <>
                <Input
                  required
                  label="Email Subject"
                  onChange={handleChange('emailSubject')}
                  invalid={errors.emailSubject && touched.emailSubject}
                  value={values.emailSubject}
                  error={errors.emailSubject}
                />
                <Input
                  required
                  type="textarea"
                  inputClass="custom-text-area"
                  label="Email List"
                  helperText="Please enter emails in each line"
                  onChange={handleChange('recipients')}
                  invalid={errors.recipients && touched.recipients}
                  value={values.recipients}
                  error={errors.recipients}
                />
                <div className="d-flex">
                  <div className="d-flex flex-1">
                    <CustomRadioBtn
                      required
                      id="frequencyType"
                      label="Period"
                      data={_period}
                      value={values.frequencyType}
                      valueKey="value"
                      labelKey="label"
                      onChange={(p) => setFieldValue('frequencyType', p)}
                      invalid={touched.frequencyType && errors.frequencyType}
                      error={errors.frequencyType}
                    />
                  </div>
                  <div className="d-flex flex-column" style={{ flex: 4 }}>
                    <FormGroup className="d-flex align-items-baseline">
                      <Label
                        htmlFor="time"
                        style={{ minWidth: 70, maxWidth: 70, marginRight: 5 }}
                      >
                        <div style={{ textAlign: 'end' }}>{t('Time')}</div>
                      </Label>
                      <DatePicker
                        id="time"
                        className="form-control"
                        wrapperClassName="w-100"
                        selected={values.time}
                        onChange={(date) => setFieldValue('time', date)}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeCaption="Time"
                        timeFormat={timeFormat}
                        dateFormat={timeFormat}
                        popperClassName="z-99"
                      />
                      <Label
                        style={{
                          minWidth: 230,
                          maxWidth: 230,
                          marginLeft: 5,
                          marginBottom: 0,
                        }}
                      >
                        {props.data.timeZone && props.data.timeZone.displayName}
                      </Label>
                    </FormGroup>
                    {errors.time && touched.time && (
                      <FormFeedback style={{ marginLeft: 75 }}>
                        {t(errors.time)}
                      </FormFeedback>
                    )}
                    {values.frequencyType !== '0' ? (
                      <div>
                        <FormGroup className="d-flex align-items-baseline mb-0">
                          <Label
                            htmlFor="onDay"
                            style={{
                              minWidth: 70,
                              maxWidth: 70,
                              marginRight: 5,
                            }}
                          >
                            <div style={{ textAlign: 'end' }}>
                              {t('On Day')}
                            </div>
                          </Label>
                          <ReactstrapInput
                            id="day"
                            type="number"
                            value={values.day}
                            onChange={handleChange('day')}
                            style={{ width: 100 }}
                          />
                          <Label
                            htmlFor="onDay"
                            style={{ marginLeft: 5, marginBottom: 0 }}
                          >
                            {t(`of the ${renderText(values.frequencyType)}`)}
                          </Label>
                        </FormGroup>
                        {errors.day && touched.day && (
                          <FormFeedback style={{ marginLeft: 75 }}>
                            {t(errors.day)}
                          </FormFeedback>
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>

                <Alert.Error text={props.errors} />
                <Button
                  id="create-scheduled-report-btn"
                  classes="mt-20"
                  loading={props.isSubmitting}
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubmit();
                  }}
                >
                  <i className="md-icon">done</i>
                  {t('Save')}
                </Button>
              </>
            )
          ) : (
            <Alert.Error text={props.unlockError} />
          )}
        </Form>
      </div>
    </Backend>
  );
};

export default ModifyEmailSchedulePage;
